import type { DeployedUnit, Phase } from "../api/types";
import { DossierUnits } from "./composition/DossierUnits";

/** Unités de l'ordre de bataille ennemi du dossier (docs/14 §2.6, §7.10b) : enveloppe de `DossierUnits` côté ennemi
 *  (docs/18 §8.2) — unités sur la carte, unités à glisser depuis la liste, menu de rôle de chaque unité. */
export function EniOdbUnits({
  onLocate,
  placeableOnly = false,
}: {
  onLocate: (unit: DeployedUnit, phase: Phase) => void;
  /** Seulement les unités à placer (ordre de bataille de la carte, qui montre déjà les autres dans son arbre). */
  placeableOnly?: boolean;
}) {
  return <DossierUnits side="ENI" onLocate={onLocate} placeableOnly={placeableOnly} />;
}
